export const formatPercentage = (
  percentage?: number,
  options: { numDecimals: number; maxFractionDigits: number } = {
    numDecimals: 2,
    maxFractionDigits: 2
  }
) => {
  if (!percentage) return '0.00%';

  const formatter = new Intl.NumberFormat('en-us', {
    style: 'percent',
    minimumFractionDigits: options.numDecimals,
    maximumFractionDigits: options.maxFractionDigits
  });

  return formatter.format(percentage / 100);
};
